import { useEffect, useRef, useState } from "react";
import Topbar from "../../components/Topbar/Topbar";
import { edit_icon } from "../../assets/img";
import { get, post, put } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { toast } from "react-toastify";
import { checkPermission } from "../redux/api/PermissionManager";

const VowSettings = () => {
  const [version, setVersion] = useState({
    user: { id: "", value: "", inReview: false },
    userIOS: { id: "", value: "", inReview: false },
    owner: { id: "", value: "", inReview: false },
    ownerIOS: { id: "", value: "", inReview: false },
    receptionist: { id: "", value: "", inReview: false },
    receptionistIOS: { id: "", value: "", inReview: false },
  });
  const tabs = ["Backend Update", "Front End OTA Update"];
  const [activeTab, setActiveTab] = useState(
    localStorage.getItem("update_tab") ?? "Backend Update",
  );

  const OTA_Feilds = [
    {
      title: "vow User",
      feilds: [
        { name: "Android", value: "user" },
        { name: "Ios", value: "userIos" },
      ],
    },
    // {
    //   title: "vow Owner",
    //   feilds: [
    //     { name: "Android", value: "owner" },
    //     { name: "Ios", value: "ownerIos" },
    //   ],
    // },
    // {
    //   title: "vow Receptionist",
    //   feilds: [
    //     { name: "Android", value: "receptionist" },
    //     { name: "Ios", value: "receptionistIos" },
    //   ],
    // },
  ];

  const [uplodedFile, setUploadedFile] = useState({
    user: null,
    userIos: null,
    owner: null,
    ownerIos: null,
    receptionist: null,
    receptionistIos: null,
  });

  const uploadeFileRef = useRef({
    user: null,
    userIos: null,
    owner: null,
    ownerIos: null,
    receptionist: null,
    receptionistIos: null,
  });

  console.log("uploaded files", uplodedFile);

  const [activeEdit, setActiveEdit] = useState(null);
  const [bundleId, setBundleId] = useState([]);

  const userRef = useRef(null);
  const userIOSRef = useRef(null);
  const ownerRef = useRef(null);
  const receptionistRef = useRef(null);
  const ownerIOSRef = useRef(null);
  const receptionistIOSRef = useRef(null);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    // Handle checkbox input
    if (type === "checkbox") {
      setVersion((prev) => ({
        ...prev,
        [name]: {
          ...prev[name],
          inReview: checked,
        },
      }));
      return;
    }

    // Handle text input
    // 🧼 Allow only numbers and dots
    let cleaned = value.replace(/[^0-9.]/g, "");

    // 🚫 Prevent multiple dots in a row (1..2)
    cleaned = cleaned.replace(/\.{2,}/g, ".");

    // 🚫 Prevent starting with a dot (.1 → 0.1)
    if (cleaned.startsWith(".")) {
      cleaned = "0" + cleaned;
    }

    setVersion((prev) => ({
      ...prev,
      [name]: {
        ...prev[name],
        value: cleaned,
      },
    }));
  };

  const handleEdit = (name) => {
    setActiveEdit((prev) => (prev === name ? null : name));

    setTimeout(() => {
      if (name === "user") userRef.current?.focus();
      if (name === "userIOS") userIOSRef.current?.focus();
      if (name === "owner") ownerRef.current?.focus();
      if (name === "ownerIOS") ownerIOSRef.current?.focus();
      if (name === "receptionist") receptionistRef.current?.focus();
      if (name === "receptionistIOS") receptionistIOSRef.current?.focus();
    }, 0);
  };

  const getInputClass = (isEditable) =>
    `input-box flex-grow-1 ${isEditable ? "input-editable" : "input-disabled"}`;

  const fetchVersion = async () => {
    const res = await get(URLS.VOW_VERSION_LIST);

    if (res?.status === "success") {
      const updatedVersion = {
        user: { id: "", value: "", inReview: false },
        userIOS: { id: "", value: "", inReview: false },
        owner: { id: "", value: "", inReview: false },
        ownerIOS: { id: "", value: "", inReview: false },
        receptionist: { id: "", value: "", inReview: false },
        receptionistIOS: { id: "", value: "", inReview: false },
      };

      res.data.forEach((item) => {
        if (item.type === 1) {
          updatedVersion.user = {
            id: item.id,
            value: item.setting_value,
            inReview: item.skip_version_check || false,
          };
        }
        if (item.type === 2) {
          updatedVersion.owner = {
            id: item.id,
            value: item.setting_value,
            inReview: item.skip_version_check || false,
          };
        }
        if (item.type === 3) {
          updatedVersion.receptionist = {
            id: item.id,
            value: item.setting_value,
            inReview: item.skip_version_check || false,
          };
        }
        if (item.type === 5) {
          updatedVersion.userIOS = {
            id: item.id,
            value: item.setting_value,
            inReview: item.skip_version_check || false,
          };
        }
        if (item.type === 6) {
          updatedVersion.ownerIOS = {
            id: item.id,
            value: item.setting_value,
            inReview: item.skip_version_check || false,
          };
        }
        if (item.type === 7) {
          updatedVersion.receptionistIOS = {
            id: item.id,
            value: item.setting_value,
            inReview: item.skip_version_check || false,
          };
        }
      });
      setBundleId(res?.data);
      setVersion(updatedVersion);
    }
  };

  useEffect(() => {
    fetchVersion();
  }, []);

  const handleSubmit = async () => {
    if (!activeEdit) {
      toast.error("Please select a version to update");
      return;
    }
    const currentData = version[activeEdit];
    const value = currentData.value.trim();
    const inReview = currentData.inReview; // Fixed typo: inReveiew -> inReview

    const numberRegex = /^\d+(\.\d+)+$/;

    if (!value) {
      toast.error("Version value is required");
      return;
    }

    if (!numberRegex.test(value)) {
      toast.error("Version value format is incorrect"); // Fixed typo
      return;
    }

    const typeMap = {
      user: 1,
      owner: 2,
      receptionist: 3,
      userIOS: 5,
      ownerIOS: 6,
      receptionistIOS: 7,
    };
    const payload = new FormData();
    payload.append("type", typeMap[activeEdit]);
    payload.append("setting_value", value);
    payload.append("skip_version_check", inReview);

    // Uncomment when API is ready:
    let url = URLS.VOW_VERSION_UPDATE + `${currentData.id}` + "/update/";
    let res = await put(url, payload);
    if (res?.status == "success") {
      toast.success(res?.message);
      setActiveEdit(null);
      fetchVersion();
    }
  };

  const handleUpload = async (type) => {
    if (!uplodedFile[type]) {
      toast.error(`Kindly upload ${type} bundle file to proceed`);
      return;
    }
    console.log("uplodedFile", type, uplodedFile[type]);

    let build_type = {
      user: 9,
      userIos: 10,
      owner: null,
      ownerIos: null,
      receptionist: null,
      receptionistIos: null,
    };

    let formdata = new FormData();
    formdata.append("image", uplodedFile[type]);
    formdata.append("type", build_type[type]);
    formdata.append("ota_enabled", true);
    formdata.append("setting_value", 1234);

    let bundleCreated = bundleId.find((item) => item?.type == build_type[type]);
    let url = Boolean(bundleCreated)
      ? `${URLS.VOW_VERSION_UPDATE}${bundleCreated?.id}/update/`
      : URLS.VOW_BUNDLE_CREATE;

    let method = Boolean(bundleCreated) ? put : post;

    let res = await method(url, formdata);
    if (res?.status == "success") {
      setUploadedFile((prev) => ({
        ...prev,
        [type]: null,
      }));
      if (uploadeFileRef.current[type]) {
        uploadeFileRef.current[type].value = null;
      }
      toast.success(res?.message);
    }
  };

  return (
    <div>
      <Topbar header="Vow Settings" />

      <div className="d-flex gap-3 mt-3 mb-3">
        {tabs.map((tab) => (
          <button
            onClick={() => {
              setActiveTab(tab);
              localStorage.setItem("update_tab", tab);
            }}
            className={`f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 request-btn ${
              activeTab === tab ? "active-btn1" : "inactive-btn"
            }`}
            aria-pressed={activeTab === tab}
          >
            {tab}
          </button>
        ))}
      </div>

      <div
        className="mt-3"
        style={{ display: activeTab === "Backend Update" ? "block" : "none" }}
      >
        <h2 className="f2 fs-sm-16 fs-md-18 fs-lg-20 fs-xl-22 fs-xxl-24 mb-4">
          Vow in-app updates
        </h2>

        {/* ---------------- Vow User Android & iOS ---------------- */}
        <div className="row mb-4">
          <div className="col-md-5">
            <h4 className="f2 mb-3">Vow User Android</h4>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                width: "80%",
              }}
            >
              <label className="f3 mb-1">Current version</label>
              <div>
                <label>In Review &nbsp;</label>
                <input
                  type="checkbox"
                  name="user"
                  onChange={handleChange}
                  checked={version.user.inReview}
                  disabled={activeEdit !== "user"}
                />
              </div>
            </div>
            <div className="d-flex align-items-center gap-5">
              <input
                ref={userRef}
                type="text"
                name="user"
                placeholder="Vow user"
                value={version.user.value}
                onChange={handleChange}
                disabled={activeEdit !== "user"}
                className={getInputClass(activeEdit === "user")}
              />
              {checkPermission("CAN-EDIT-IN-APP_CONTROL") && (
                <button className="cust-btn" onClick={() => handleEdit("user")}>
                  <img
                    src={edit_icon}
                    alt="edit"
                    className={`edit-btn ${
                      activeEdit === "user" ? "active-edit" : ""
                    }`}
                  />
                </button>
              )}
            </div>
          </div>
          <div className="col-md-5">
            <h4 className="f2 mb-3">Vow User iOS</h4>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                width: "80%",
              }}
            >
              <label className="f3 mb-1">Current version</label>
              <div>
                <label>In Review &nbsp;</label>
                <input
                  type="checkbox"
                  name="userIOS"
                  onChange={handleChange}
                  checked={version.userIOS.inReview}
                  disabled={activeEdit !== "userIOS"}
                />
              </div>
            </div>
            <div className="d-flex align-items-center gap-5">
              <input
                ref={userIOSRef}
                type="text"
                name="userIOS"
                placeholder="Vow user iOS"
                value={version?.userIOS?.value}
                onChange={handleChange}
                disabled={activeEdit !== "userIOS"}
                className={getInputClass(activeEdit === "userIOS")}
              />
              {checkPermission("CAN-EDIT-IN-APP_CONTROL") && (
                <button
                  className="cust-btn"
                  onClick={() => handleEdit("userIOS")}
                >
                  <img
                    src={edit_icon}
                    alt="edit"
                    className={`edit-btn ${activeEdit === "userIOS" ? "active-edit" : ""}`}
                  />
                </button>
              )}
            </div>
          </div>
        </div>

        <hr />

        {/* ---------------- Vow Owner Android & iOS ---------------- */}
        <div className="row mb-4">
          <div className="col-md-5">
            <h4 className="f2 mb-3">Vow Owner Android</h4>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                width: "80%",
              }}
            >
              <label className="f3 mb-1">Current version</label>
              <div>
                <label>In Review &nbsp;</label>
                <input
                  type="checkbox"
                  name="owner"
                  onChange={handleChange}
                  checked={version.owner.inReview}
                  disabled={activeEdit !== "owner"}
                />
              </div>
            </div>
            <div className="d-flex align-items-center gap-5">
              <input
                ref={ownerRef}
                type="text"
                name="owner"
                placeholder="Vow owner"
                value={version.owner.value}
                onChange={handleChange}
                disabled={activeEdit !== "owner"}
                className={getInputClass(activeEdit === "owner")}
              />
              {checkPermission("CAN-EDIT-IN-APP_CONTROL") && (
                <button
                  className="cust-btn"
                  onClick={() => handleEdit("owner")}
                >
                  <img
                    src={edit_icon}
                    alt="edit"
                    className={`edit-btn ${
                      activeEdit === "owner" ? "active-edit" : ""
                    }`}
                  />
                </button>
              )}
            </div>
          </div>

          <div className="col-md-5">
            <h4 className="f2 mb-3">Vow Owner iOS</h4>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                width: "80%",
              }}
            >
              <label className="f3 mb-1">Current version</label>
              <div>
                <label>In Review &nbsp;</label>
                <input
                  type="checkbox"
                  name="ownerIOS"
                  onChange={handleChange}
                  checked={version.ownerIOS.inReview}
                  disabled={activeEdit !== "ownerIOS"}
                />
              </div>
            </div>
            <div className="d-flex align-items-center gap-5">
              <input
                ref={ownerIOSRef}
                type="text"
                name="ownerIOS"
                placeholder="Vow owner iOS"
                value={version?.ownerIOS?.value}
                onChange={handleChange}
                disabled={activeEdit !== "ownerIOS"}
                className={getInputClass(activeEdit === "ownerIOS")}
              />
              {checkPermission("CAN-EDIT-IN-APP_CONTROL") && (
                <button
                  className="cust-btn"
                  onClick={() => handleEdit("ownerIOS")}
                >
                  <img
                    src={edit_icon}
                    alt="edit"
                    className={`edit-btn ${activeEdit === "ownerIOS" ? "active-edit" : ""}`}
                  />
                </button>
              )}
            </div>
          </div>
        </div>

        <hr />

        {/* ---------------- Vow Receptionist Android & iOS ---------------- */}
        <div className="row mb-4">
          <div className="col-md-5">
            <h4 className="f2 mb-3">Vow Receptionist Android</h4>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                width: "80%",
              }}
            >
              <label className="f3 mb-1">Current version</label>
              <div>
                <label>In Review &nbsp;</label>
                <input
                  type="checkbox"
                  name="receptionist"
                  onChange={handleChange}
                  checked={version.receptionist.inReview}
                  disabled={activeEdit !== "receptionist"}
                />
              </div>
            </div>
            <div className="d-flex align-items-center gap-5">
              <input
                ref={receptionistRef}
                type="text"
                name="receptionist"
                placeholder="Vow receptionist"
                value={version.receptionist.value}
                onChange={handleChange}
                disabled={activeEdit !== "receptionist"}
                className={getInputClass(activeEdit === "receptionist")}
              />
              {checkPermission("CAN-EDIT-IN-APP_CONTROL") && (
                <button
                  className="cust-btn"
                  onClick={() => handleEdit("receptionist")}
                >
                  <img
                    src={edit_icon}
                    alt="edit"
                    className={`edit-btn ${
                      activeEdit === "receptionist" ? "active-edit" : ""
                    }`}
                  />
                </button>
              )}
            </div>
          </div>

          <div className="col-md-5">
            <h4 className="f2 mb-3">Vow Receptionist iOS</h4>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                width: "80%",
              }}
            >
              <label className="f3 mb-1">Current version</label>
              <div>
                <label>In Review &nbsp;</label>
                <input
                  type="checkbox"
                  name="receptionistIOS"
                  onChange={handleChange}
                  checked={version.receptionistIOS.inReview}
                  disabled={activeEdit !== "receptionistIOS"}
                />
              </div>
            </div>
            <div className="d-flex align-items-center gap-5">
              <input
                ref={receptionistIOSRef}
                type="text"
                name="receptionistIOS"
                placeholder="Vow receptionist iOS"
                value={version?.receptionistIOS?.value}
                onChange={handleChange}
                disabled={activeEdit !== "receptionistIOS"}
                className={getInputClass(activeEdit === "receptionistIOS")}
              />
              {checkPermission("CAN-EDIT-IN-APP_CONTROL") && (
                <button
                  className="cust-btn"
                  onClick={() => handleEdit("receptionistIOS")}
                >
                  <img
                    src={edit_icon}
                    alt="edit"
                    className={`edit-btn ${activeEdit === "receptionistIOS" ? "active-edit" : ""}`}
                  />
                </button>
              )}
            </div>
          </div>
        </div>

        {checkPermission("CAN-EDIT-IN-APP_CONTROL") && (
          <div className="d-flex ac-jb mt-5">
            <div />
            <button
              onClick={handleSubmit}
              className="submit-btn mt-3"
              style={{ background: !activeEdit ? "#ddd" : "" }}
              disabled={!activeEdit}
            >
              Update
            </button>
          </div>
        )}
      </div>

      {/* OTA UPDATE  */}
      <div
        style={{
          display: activeTab === "Front End OTA Update" ? "block" : "none",
        }}
      >
        <h2 className="f2 fs-sm-16 fs-md-18 fs-lg-20 fs-xl-22 fs-xxl-24 my-4">
          Front End OTA Update (Android & IOS)
        </h2>
        {OTA_Feilds.map((item, ind) => {
          return (
            <>
              {ind != 0 && (
                <hr
                  className="primary mt-3 mb-3 "
                  style={{
                    borderWidth: "2px",
                    opacity: 1,
                  }}
                />
              )}
              <div className="mt-3 d-flex ac-js gap-3 flex-wrap">
                {item.feilds.map((feild) => {
                  return (
                    <div className="col-md-4 card px-4 py-3 shadow">
                      <h3 className="f2 fs-sm-16 fs-md-18 fs-lg-20 fs-xl-22 fs-xxl-24 mb-4">
                        {item.title} ({feild.name})
                      </h3>
                      <p className="text-muted  red">
                        Upload a ZIP file only (maximum size: 5 MB).
                      </p>
                      <div className="mt-3 d-flex ac-js">
                        <input
                          type="file"
                          ref={(el) =>
                            (uploadeFileRef.current[feild.value] = el)
                          }
                          accept=".zip,application/zip"
                          className="border p-2 pt-3 pb-3 "
                          onChange={(e) => {
                            const file = e.target.files?.[0];

                            if (file) {
                              const maxSize = 5 * 1024 * 1024;

                              if (file.size > maxSize) {
                                toast.error(
                                  "File size must be less than 5 MB.",
                                );
                                e.target.value = "";
                              } else {
                                setUploadedFile((prev) => ({
                                  ...prev,
                                  [feild.value]: file,
                                }));
                              }
                            }
                          }}
                        />
                      </div>
                      <div className="d-flex ac-jc">
                        <button
                          className="submit-btn my-5"
                          onClick={() => handleUpload(feild.value)}
                        >
                          Upload
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            </>
          );
        })}
      </div>
    </div>
  );
};

export default VowSettings;
